import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import InvoiceEventHub from "@/components/invoice/InvoiceEventHub";

export default Vue.component('potential-invoice-totals-card', {
  name: 'PotentialInvoiceTotalsCard',
  props: {
    facilityId: {type: [Number, String]},
    specialtyId: {type: [Number, String]},
    invoiceStartDate: {type: [Date, String]},
    invoiceId: {type: [Number, String]},
    mergedInvoiceId: {type: [Number, String]},
    isSpecial: {type: Boolean}
  },
  data() {
    return {
      cardExpanded: false,
      total: 0,
      transactions: [],
      invoiceEndDate: null
    }
  },

  components: {
    VueSimpleSpinner
  },
  mixins: [HttpMixin],
  async created() {
    await this.expandCard();
    InvoiceEventHub.$on('INVOICE_CHANGE', this.dataFetchWrapper);
  },
  beforeDestroy: function () {
    InvoiceEventHub.$off('INVOICE_CHANGE', this.dataFetchWrapper);
  },
  methods: {
    // this comment copypasta is to denote that this function is to work around a leak caused by using anonymous functions in the event callback.
    // per this issue comment https://github.com/vuejs/vue-router/issues/1181#issuecomment-281084486
    // testing bears this out to be true and was causing unnecessary data fetches as well as bugs with incorrect route redirects
    dataFetchWrapper() {
      this.lazyLoadTotals().then(() => {}).catch(() => '');
    },
    async lazyLoadTotals() {
      if (this.cardExpanded) {
        await this.loadTotals()
      }
    },
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadTotals();
      }
    },
    async loadTotals() {
      const url = this.isSpecial ? this.getSpecialInvoiceUrl() : this.getInvoiceUrl();
      const data = await (this as any).httpGet(url, 'Error retrieving Totals Preview');
      if (data) {
        this.total = data.total;
        this.transactions = data.transactions;
        this.invoiceEndDate = data.invoiceEndDate;
      }
    },
    getInvoiceUrl() {
      let parameters;
      if (this.mergedInvoiceId) {
        parameters = `mergedInvoiceId=${this.mergedInvoiceId}`;
      } else if (this.invoiceId) {
        parameters = `invoiceId=${this.invoiceId}`;
      } else if (this.facilityId && this.specialtyId && this.invoiceStartDate) {
        parameters = `facilityId=${this.facilityId}&specialtyId=${this.specialtyId}&invoiceDate=${this.invoiceStartDate}`;
      } else {
        throw new Error("Error retrieving Invoice Information");
      }
      return `/invoices/transactions/totals-preview?${parameters}`;
    },
    getSpecialInvoiceUrl() {
      return `/special-invoices/transactions/totals-preview?invoiceId=${this.invoiceId}`;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/cards/potentialTotals/PotentialInvoiceTotalsCard.ts